const hostApi = "https://api.awardtool.com/";
// const hostApi = "http://127.0.0.1/";

export { hostApi };
